import { useCallback } from 'react'

import useMutateURLSearchParams from 'utils/hooks/routes/useMutateURLSearchParams'
import { useURLSearchParams } from 'utils/hooks/routes/useURLSearchParams'

const searchKey = 'search'

export default function useSearch() {
  const search = useURLSearchParams((query) => String(query?.[searchKey] ?? ''))
  const mutateURLParams = useMutateURLSearchParams()
  const setSearch = useCallback((input: string) => mutateURLParams({ [searchKey]: input }), [searchKey])

  return { search, setSearch }
}
